export default __webpack_public_path__ + "static/media/profile_image.c8480d8f.jpeg";